import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { Message_Type } from 'src/app/core/models/enums/message-type';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { CropResponse } from 'src/app/core/models/interfaces/crop-response';
import { ClientAlertService } from 'src/app/core/services/client-alert.service';
import { DoktarConstantsService } from 'src/app/core/services/doktar-constants.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { FarmDeviceDetailItem } from '../../models/farm-device.model';
import { DetailService } from '../../services/detail.service'
import { FarmEditComponent } from '../farm-edit/farm-edit.component';
import { SensorSelectionComponent } from '../sensor-selection/sensor-selection.component';
import { CropInformationsEditComponent } from '../crop-informations-edit/crop-informations-edit.component';
import { DeviceInfoUpdateComponent } from '../device-info-update/device-info-update.component';
import { SetDateFilterComponent } from 'src/app/core/helper/components/set-date-filter/set-date-filter.component';
import { FilizHomeService } from 'src/app/pages/filiz/services/filiz-home.service';
import { CustomBottomAlertComponent } from 'src/app/core/helper/components/custom-bottom-alert/custom-bottom-alert.component';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { FarmApiService } from 'src/app/core/api/farm-api.service';
import { IFarmSaveModel } from 'src/app/core/models/interfaces/farm-save-model';
import { PhotoCaptureTimeComponent } from '../../profile/components/photo-capture-time/photo-capture-time.component';
import { ProfileService } from '../../profile/services/profile.service';

@Component({
  selector: 'app-farm-device-detail',
  templateUrl: './farm-device-detail.component.html',
  styleUrls: ['./farm-device-detail.component.scss'],
})
export class FarmDeviceDetailComponent implements OnInit {
  querySubs: Subscription;
  tempFarmAttrId: number;
  sensorType: string = "";
  detailItem: FarmDeviceDetailItem;
  farmImage
  farmImageAlt
  farmCoords
  filizMode
  deviceType
  databaseError: boolean = false;
  harvested: boolean = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private detailService: DetailService,
    private loadingService: LoadingService,
    private router: Router,
    private translateService: TranslateService,
    private toastService: ToastService,
    private alertService: ClientAlertService,
    private modalService: ModalService,
    public storageService: StorageService,
    private doktarConstantService: DoktarConstantsService,
    public dateTimeService: DateTimeService,
    private farmApiService: FarmApiService,
    private profileService: ProfileService) { }

  ngOnInit() { }

  ionViewDidEnter() {
    this.storageService.get(StorageKeys.FILIZ_MODE).then(res => {
      if (res.IsSuccess) {
        this.filizMode = res.Data;
      }
    });
    this.querySubs = this.activatedRoute.queryParams.subscribe(e => {
      if (e["farmId"]) {
        this.tempFarmAttrId = +e["farmId"];
      }
      if (e["sensorType"]) {
        this.sensorType = e["sensorType"];
      }
    });
    this.getDetail();


  }

  ionViewDidLeave() {
    if (typeof this.querySubs != "undefined") {
      this.querySubs.unsubscribe();
    }
  }

  getDetail() {
    this.loadingService.showLoading();
    this.detailService.getDetail(this.sensorType, this.tempFarmAttrId).subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.databaseError = false;
        this.detailItem = res.Data;
        let geoJsonParsed = JSON.parse(this.detailItem.Location);
        geoJsonParsed.properties = { "fill": "#FFB83D", "stroke": "#FFFFFF", "stroke-width": "3" }
        let geojson = encodeURIComponent(JSON.stringify(geoJsonParsed));
        this.farmImage = `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/geojson(${geojson})/auto/600x400@2x?padding=75&&access_token=pk.eyJ1IjoibXN0ZmNpbmFyIiwiYSI6ImNrbHQ3bGhjeTIzcDUydnF5c3BvZHE0bm8ifQ.ms7GiuDSI8ZqDI-EFp_D1Q&attribution=false&logo=false`
        this.farmImageAlt = `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/static/geojson(${geojson})/auto/600x400@2x?padding=150&&access_token=pk.eyJ1IjoibXN0ZmNpbmFyIiwiYSI6ImNrbHQ3bGhjeTIzcDUydnF5c3BvZHE0bm8ifQ.ms7GiuDSI8ZqDI-EFp_D1Q&attribution=false&logo=false`
        this.farmCoords = geoJsonParsed.geometry.coordinates[0][0].reverse().map(t => Math.round(t * 1000) / 1000).join(",")
        this.detailItem.Center = {
          lat: geoJsonParsed.geometry.coordinates[0][0][1],
          lng: geoJsonParsed.geometry.coordinates[0][0][0]
        }
        this.getCropList().subscribe(e => {
          if (e) {
            this.selectedCrop = this.cropList.find(crop => crop.CropId == this.detailItem.CropId);
          }
        });
        if (this.dateTimeService.daysBetween(new Date(), new Date(this.detailItem.HarvestDate)) < 0) {
          this.harvested = true;
        } else {
          this.harvested = false;
        }
      } else {
        this.databaseError = true;
      }
    }, err => {
      this.databaseError = true;
      this.loadingService.hideLoading();
    });
  }

  selectedCrop: CropResponse;
  cropList: Array<CropResponse> = [];
  getCropList(): Observable<boolean> {
    return new Observable(observer => {
      this.doktarConstantService.RequestCropList(false).subscribe(cropResponse => {
        if (cropResponse) {
          this.cropList = cropResponse;
          observer.next(true);
        }
      })
    });
  }

  editDevice() {
    // let modalId = Date.now();
    // this.modalService.presentModal({
    //   id: modalId,
    //   component: DeviceInfoUpdateComponent,
    //   componentProps: { detailItem: this.detailItem },
    //   options: ModalService.defaultOptionsTransparent
    // }).then(e => {
    //   this.modalService.modalOnDidDismiss(modalId).then(e => {
    //     if (e.role == "success")
    //       this.getDetail();
    //   });
    // })
    let url = this.router.url;
    this.router.navigate(["/common/detail/device-update"], {
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }
  editFarm() {
    let modalId = Date.now();
    this.modalService.presentModal({
      id: modalId,
      component: FarmEditComponent,
      componentProps: { detailItem: this.detailItem },
      options: ModalService.defaultOptionsTransparent
    }).then(e => {
      this.modalService.modalOnDidDismiss(modalId).then(e => {
        if (e.role == "success")
          this.getDetail();
      });
    })
  }

  refresh() {
    this.getDetail();
  }

  deleteImportedOrSharedField() {
    let deviceType
    if (this.filizMode) {
      deviceType = "filiz"
    } else {
      deviceType = "trap"
    }
    let payload = {
      "TempFarmAttId": this.detailItem.TempFarmAttId,
      "DeviceType": deviceType
    }
    this.detailService.deleteField(payload).subscribe(e => {
      this.loadingService.hideLoading();
      if (e.IsSuccess) {
        if (this.detailItem.IsImported) {
          this.toastService.PresentBasicToast({ message: this.translateService.instant("detail.removed-field-title") + this.translateService.instant("detail.removed-field-desc", { value: this.detailItem.SharedApplications }), type: Message_Type.SUCCESS, duration: 5000 });
        } else {
          this.toastService.PresentBasicToast({ message: this.translateService.instant("detail.deleted-field-title") + this.translateService.instant("detail.deleted-field-desc"), type: Message_Type.SUCCESS, duration: 5000 });
        }
        this.storageService.set(StorageKeys.mapUpdated, true).then();
        if (this.sensorType == "trap") {
          this.storageService.lastTrapFarmId = null;
          this.storageService.set(StorageKeys.LAST_TRAP_FARM, null).then(trap => {
            this.router.navigateByUrl("/pesttrapp/home");
          });

        } else {
          this.storageService.lastFilizFarmId = null;
          this.storageService.set(StorageKeys.LAST_FILIZ_FARM, null).then(filiz => {
            this.router.navigateByUrl("/filiz/home");
          });
        }
      } else {
        if (e.ValidationErrors && e.ValidationErrors.length > 0)
          this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.ValidationErrors[0]), type: Message_Type.DANGER, duration: 3000 });
        else
          this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.Message), type: Message_Type.DANGER, duration: 3000 });
      }
    });
  }

  deleteImportedFieldModal() {
    let deleteFieldCallback = (ev, modalId) => {
      this.modalService.dismissByModalId(modalId, {}, "buttonClicked");
      this.deleteImportedOrSharedField();
    }

    let cancelCallback = (ev, modalId) => {
      this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
    }
    this.alertService.BottomSheetAlert({
      buttons: [
        { callback: deleteFieldCallback, color: "primary", fill: "solid", text: this.translateService.instant("general.yes-sure") },
        { callback: cancelCallback, color: "dark", fill: "clear", text: this.translateService.instant("general.cancel-remove") }
      ],
      title: this.translateService.instant("detail.imported-field-delete", { value: " " + this.detailItem.FarmName }),
      description: this.translateService.instant("detail.delete-imported-field-desc", { value: this.detailItem.SharedApplications }),
      svg: JSON.parse(this.detailItem.Location),
    }).then(response => { })
  }

  deleteField() {
    this.detailService.getFarmSharedList(this.detailItem.TempFarmAttId).subscribe(res => {
      if (res.IsSuccess) {
        if (res?.Data.length > 0) {
          let deleteFieldCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked");
            this.deleteImportedOrSharedField();
          }

          let cancelCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
          }
          this.alertService.BottomSheetAlert({
            buttons: [
              { callback: deleteFieldCallback, color: "danger", fill: "solid", text: this.translateService.instant("general.delete-anyway") },
              { callback: cancelCallback, color: "black", fill: "clear", text: this.translateService.instant("detail.cancel-delete") }
            ],
            title: this.translateService.instant("detail.shared-field-delete", { value: " " + this.detailItem.FarmName }),
            description: this.translateService.instant("detail.delete-shared-field-desc"),
            svg: JSON.parse(this.detailItem.Location),
          }).then(response => { })
        } else {
          this.alertService.confirmAlertController(this.translateService.instant("detail.farm-delete")).then(() => {
            this.alertService.alert.onDidDismiss().then(res => {
              if (res.data == true) {
                this.loadingService.showLoading();
                let deviceType
                if (this.filizMode) {
                  deviceType = "filiz"
                } else {
                  deviceType = "trap"
                }
                let payload = {
                  "TempFarmAttId": this.detailItem.TempFarmAttId,
                  "DeviceType": deviceType
                }
                this.detailService.deleteField(payload).subscribe(e => {
                  this.loadingService.hideLoading();
                  if (e.IsSuccess) {
                    this.storageService.set(StorageKeys.mapUpdated, true).then();
                    if (this.sensorType == "trap") {
                      this.storageService.lastTrapFarmId = null;
                      this.storageService.set(StorageKeys.LAST_TRAP_FARM, null).then(trap => {
                        this.router.navigateByUrl("/pesttrapp/home");
                      });

                    } else {
                      this.storageService.lastFilizFarmId = null;
                      this.storageService.set(StorageKeys.LAST_FILIZ_FARM, null).then(filiz => {
                        this.router.navigateByUrl("/filiz/home");
                      });
                    }
                  } else {
                    if (e.ValidationErrors && e.ValidationErrors.length > 0)
                      this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.ValidationErrors[0]), type: Message_Type.DANGER, duration: 3000 });
                    else
                      this.toastService.PresentBasicToast({ message: this.translateService.instant("errors." + e.Message), type: Message_Type.DANGER, duration: 3000 });
                  }
                });
              }
            });
          });
        }
      }
    })
    return

  }

  changeSensorValue() {
    let modalId = Date.now();
    this.modalService.presentModal({
      id: modalId,
      component: SensorSelectionComponent,
      componentProps: {
        detailItem: this.detailItem,
        page: 'farm-detail'
      },
      options: ModalService.defaultOptionsTransparent
    }).then(e => {
      this.modalService.modalOnDidDismiss(modalId).then(e => {
        if (e.role == "success") {
          if (this.sensorType == "trap") {
            this.storageService.lastTrapFarmId = null;
            this.storageService.set(StorageKeys.updated, true).then();

          } else {
            this.storageService.lastFilizFarmId = null;
            this.storageService.set(StorageKeys.updated, true).then();
          }
          this.getDetail();
          let cancelCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
          }
          this.alertService.PopupAlert({
            buttons: [
              { callback: cancelCallback, color: "primary", fill: "clear", text: this.translateService.instant("general.ok") }
            ],
            title: this.translateService.instant("detail.sensor_notification_title"),
            description: this.translateService.instant("soil-sensor.sensor-notification-desc-" + e.data),
            icon: "checkmark-circle",
            role: 'success'
          }).then(response => { })
        } else if (e.role == "error") {
          // this.getDetail();
          let cancelCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
          }
          this.alertService.PopupAlert({
            buttons: [
              { callback: cancelCallback, color: "primary", fill: "clear" }
            ],
            title: this.translateService.instant("detail.sensor_notification_err"),
            icon: "cloud-offline",
            role: 'danger'
          }).then(response => { })
        }
      })
    });
  }

  editCropInfo() {
    let modalId = Date.now();
    this.modalService.presentModal({
      id: modalId,
      component: CropInformationsEditComponent,
      componentProps: { detailItem: this.detailItem },
      options: ModalService.defaultOptionsTransparent
    }).then(e => {
      this.modalService.modalOnDidDismiss(modalId).then(e => {
        if (e.role == "success")
          this.getDetail();
      });
    })
  }

  setChillingDate() {
    let center = [this.detailItem.Center["lat"], this.detailItem.Center["lng"]];
    this.modalService.presentModal({
      component: SetDateFilterComponent,
      componentProps: {
        title: "filiz-home.set-date",
        subTitle: "filiz-home.chilling-set-date-title",
        buttonAvailable: true,
        buttonName: "filiz-home.choose-date",
        startDate: this.detailItem.ChillingStartDate ? this.detailItem.ChillingStartDate : new Date(),
        endDate: this.detailItem.ChillingEndDate ? this.detailItem.ChillingEndDate : new Date(),
        firstDateName: 'filiz-home.start-date',
        secondDateName: 'filiz-home.end-date',
        deviceId: this.detailItem.DeviceId,
        polygonCenter: center
      },
      options: ModalService.defaultOptionsTransparent
    }).then(modal => {
      modal.modalObj.onDidDismiss().then(res => {
        if (res.role == 'filter-obj') {
          if (res.data) {
            let payload: IFarmSaveModel = {
              CalculatedArea: this.detailItem.CalculatedArea,
              CropId: this.detailItem.CropId,
              CropVarietyId: this.detailItem.CropVarietyId,
              FarmName: this.detailItem.FarmName,
              GeoJson: this.detailItem.Location,
              HarvestDate: this.detailItem.HarvestDate ? this.detailItem.HarvestDate : "1970-01-01",
              SowingDate: this.detailItem.SowingDate ? this.detailItem.SowingDate : "1970-01-01",
              TempFarmAttId: this.detailItem.TempFarmAttId,
              IrrigationTypeId: this.detailItem.IrrigationTypeId,
              SensorId: this.detailItem.SensorId,
              SoilTypeId: this.detailItem.SoilTypeId,
              FarmingMethodId: this.detailItem.FarmingMethodId,
              PhId: 44,
              ChillingStartDate: res.data.startDate,
              ChillingEndDate: res.data.endDate
            }
            this.farmApiService.FarmSave(payload, "filiz").subscribe(chilling => {
              this.storageService.lastFilizFarmId = null;
              this.storageService.lastTrapFarmId = null;
              this.storageService.set(StorageKeys.updated, true).then();
              if (chilling.IsSuccess) {
                this.modalService.presentModal({
                  component: CustomBottomAlertComponent,
                  componentProps: {
                    title: this.translateService.instant("filiz-home.set-and-done"),
                    description: this.translateService.instant("filiz-home.chilling-desc", { value: this.dateTimeService.formatDate(res.data.startDate, "DD.MM.YYYY") }),
                    buttonName: this.translateService.instant("filiz-home.got-it"),
                    image: '../../../../../assets/images/chilling-success.svg',
                    imageHeight: 100
                  },
                  options: ModalService.defaultOptionsTransparent
                }).then(modal => {
                  modal.modalObj.onDidDismiss().then(res => {
                    if (res) {
                      this.getDetail();
                    }
                  })
                }).catch(err => {
                });
              }
            })
          }
        }
      })
    });
  }
  changePhotoCapture() {
    this.modalService.presentModal({
      component: PhotoCaptureTimeComponent,
      componentProps: {
        timeArray: this.detailItem.ImageFrequency
      },
      options: ModalService.defaultOptionsTransparent,
    }).then(e => {
      e.modalObj.onDidDismiss().then(res => {
        if (res.role == "update") {
          this.saveResValue("W", res.data, 0);
        }
      });
    });
  }
  saveResValue(key: string, value: string, offset: number) {
    let payload = {
      DeviceId: this.detailItem.DeviceId,
      Key: key,
      Value: value,
      OffSet: offset
    }
    this.loadingService.showLoading();
    this.profileService.saveResponseValue(payload).subscribe(e => {
      this.loadingService.hideLoading();
      if (e.IsSuccess) {
        this.getDetail();
      }
    });
  }
}
